function manageCartGifts() {
  console.log("manageCartGifts Calling 0000000000000000000000")
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const items = cart.items;
      const hasSubscription = items.some(item => item.selling_plan_allocation);
      const shippingDiv = document.querySelector("[data-shipping-progress]");

      const subscriptionFreeProductId = 51765246067058;
      const tieredFreeProductId = parseInt(shippingDiv.getAttribute("data-tiered_product_2"));
      const tieredAmountThreshold = parseFloat(shippingDiv.getAttribute("data-tiered-2-amount"));
      const cartAmount = parseFloat(shippingDiv.getAttribute("cart-total"));

      const lineItemUpdates = {};
      let addTieredGift = false;

      // Check existing items
      let subscriptionGiftInCart = false;
      let tieredGiftInCart = false;
      let nonGiftItemsCount = 0;

      items.forEach(item => {
        if (item.variant_id === subscriptionFreeProductId) subscriptionGiftInCart = true;
        if (item.variant_id === tieredFreeProductId) tieredGiftInCart = true;
        if (![subscriptionFreeProductId, tieredFreeProductId].includes(item.variant_id)) {
          nonGiftItemsCount += item.quantity;
        }
      });

      // 🧹 Remove subscription gift if no subscription product
      if (!hasSubscription && subscriptionGiftInCart) {
        const itemKey = items.find(i => i.variant_id === subscriptionFreeProductId).key;
        lineItemUpdates[itemKey] = 0;
      }

      // 🎁 Handle tiered gift
      if (cartAmount >= tieredAmountThreshold && !tieredGiftInCart && nonGiftItemsCount > 0) {
        addTieredGift = true;
      } else if ((cartAmount < tieredAmountThreshold || nonGiftItemsCount <= 0) && tieredGiftInCart) {
        const itemKey = items.find(i => i.variant_id === tieredFreeProductId).key;
        lineItemUpdates[itemKey] = 0;
      }

      if (Object.keys(lineItemUpdates).length > 0) {
        updateCartItems(lineItemUpdates, () => {
          if (addTieredGift) {
            addFreeGift(tieredFreeProductId);
          }
        });
      } else if (addTieredGift) {
        addFreeGift(tieredFreeProductId);
      } else {
        $('.drawer_loading').addClass('hidden');
      }
    })
    .catch(err => {
      console.error("Error processing cart:", err);
      $('.drawer_loading').addClass('hidden');
    });
}

// 🔁 Batch update cart (removal)
function updateCartItems(lineItemUpdates, callback) {
  const cartDrawer = document.querySelector('cart-drawer');
  const sectionsToRender = cartDrawer.getSectionsToRender().map(section => section.id);
  const sections_url = window.location.pathname;

  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: {
      updates: lineItemUpdates,
      sections: sectionsToRender,
      sections_url: sections_url
    },
    dataType: 'json',
    success: function (response) {
      cartDrawer.renderContents(response);
      cartDrawer.open();
      cartDrawer.classList.toggle('is-empty', response.item_count === 0);
      if (typeof callback === 'function') callback();
      $('.drawer_loading').addClass('hidden');
    },
    error: function (xhr, status, error) {
      console.error('Error updating cart:', error);
      $('.drawer_loading').addClass('hidden');
    }
  });
}

// 🎁 Add free gift
function addFreeGift(variantId) {
  const cartDrawer = document.querySelector('cart-drawer');
  const sectionsToRender = cartDrawer.getSectionsToRender().map(section => section.id);
  const sections_url = window.location.pathname;

  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      quantity: 1,
      id: variantId,
      sections: sectionsToRender,
      sections_url: sections_url
    })
  })
    .then(response => response.json())
    .then(response => {
      cartDrawer.renderContents(response);
      $('.drawer_loading').addClass('hidden');
    })
    .catch(error => {
      console.error("Error adding gift:", error);
      $('.drawer_loading').addClass('hidden');
    });
}
